import { unreachable } from '../../../../ts-utils';
import { canHaveVotes } from '../top-level-comments/top-level-comment-types';
import { VOTE_ON_COMMENT_FAILURE, VOTE_ON_COMMENT_REQUEST, VOTE_ON_COMMENT_SUCCESS, } from './comments-vote-actions';
import { hiddenComponentEffectsGuard } from '../effects/hidden-component-effects-guard';
export const commentsVoteReducer = (state, action) => {
    switch (action.type) {
        case VOTE_ON_COMMENT_REQUEST: {
            const { commentId, nextCurrentUserVoteState } = action.payload;
            const commentState = state.commentsById[commentId];
            if (!canHaveVotes(commentState)) {
                return state;
            }
            return {
                ...state,
                commentsById: {
                    ...state.commentsById,
                    [commentId]: {
                        ...commentState,
                        votes: {
                            ...commentState.votes,
                            currentUserVote: nextCurrentUserVoteState,
                        },
                    },
                },
            };
        }
        case VOTE_ON_COMMENT_FAILURE: {
            const { commentId, error, nextCurrentUserVoteState } = action.payload;
            const commentState = state.commentsById[commentId];
            if (!canHaveVotes(commentState)) {
                return state;
            }
            return {
                ...state,
                commentsById: {
                    ...state.commentsById,
                    [commentId]: {
                        ...commentState,
                        votes: {
                            ...commentState.votes,
                            currentUserVote: nextCurrentUserVoteState,
                        },
                    },
                },
                ...hiddenComponentEffectsGuard(state, {
                    highlight: { type: 'CRUD_ERROR', id: commentId, timestamp: Date.now() },
                    toast: error.type === 'SILENT'
                        ? state.effects?.toast
                        : { skin: 'error', message: error, timestamp: Date.now() },
                }),
            };
        }
        case VOTE_ON_COMMENT_SUCCESS: {
            const { commentId, nextCurrentUserVoteState } = action.payload;
            const commentState = state.commentsById[commentId];
            if (!canHaveVotes(commentState)) {
                return state;
            }
            return {
                ...state,
                commentsById: {
                    ...state.commentsById,
                    [commentId]: {
                        ...commentState,
                        votes: {
                            ...commentState.votes,
                            currentUserVote: nextCurrentUserVoteState,
                        },
                    },
                },
            };
        }
        default:
            throw unreachable(action);
    }
};
//# sourceMappingURL=comments-vote-reducer.js.map